import { FormEvent, useEffect, useState, useCallback } from 'react'
import { RootStateAuth } from '../../store/authReducer';

import { View } from 'base/src/components/Basic/View/view';
import { GetSistemas } from 'base/src/store/sistema/action/sistemaAction';
import StateMensage from 'base/src/view/states/state'
import { SISTEMAS_GET } from 'domain/types/sistema/sistema';

import * as S from './styles';
import WdLogo from 'base/src/components/WDLogo';
import { Redirect, RouteParamters } from 'base/src/utils/routeUtil';
import { SistemaResponse } from 'domain/types/sistema/sistemaResponse';
import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { Input } from 'base/src/components/Input';
import { Forms } from 'base/src/components/Form';
import { toast } from 'react-toastify';

const connector = connectUtil(
  (state: RootStateAuth) => ({
    sistemas: state.SistemaReducer.sistemas,
  }),
  { GetSistemas }
);

export interface CentralComponentProps extends PropsFromRedux<typeof connector> { }

function Central(props: CentralComponentProps) {

  const [modalparam, setModalParam] = useState<number | undefined>(undefined);

  // Memoizar as funções de callback para evitar re-renders desnecessários
  const handlerCard = useCallback((sistema: SistemaResponse) => {
    return () => {
      if (sistema.Parametros != null && sistema.Parametros.length > 0) {
        setModalParam(sistema.SistemaID);
      } else {
        Redirect(sistema.UrlBase, [{ key: RouteParamters.token, value: _UserData.Get(UserDataBaseEnum.Token) }]);
      }
    }
  }, []);

  const handleCloseModal = useCallback(() => {
    setModalParam(undefined);
  }, []);

  const handleModalBackdropClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    handleCloseModal();
  }, [handleCloseModal]);

  const handleModalContentClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  const handleForm = useCallback((event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const sistema = props.sistemas?.find(s => s.SistemaID === modalparam);

    if (!sistema) return;

    // Coletar todos os valores dos parâmetros
    const parametros: { [key: string]: string } = {};
    const camposVazios: string[] = [];

    sistema.Parametros?.forEach(param => {
      const value = formData.get(param) as string;

      if (!value || value.trim() === '') {
        camposVazios.push(param);
      } else {
        parametros[param] = value.trim();
      }
    });

    // Validar se há campos vazios
    if (camposVazios.length > 0) {
      toast(`Os seguintes campos são obrigatórios: ${camposVazios.join(', ')}`);
      return;
    }

    // Se todos os campos estão preenchidos, construir parâmetros para redirect
    const urlParams = [
      { key: RouteParamters.token, value: _UserData.Get(UserDataBaseEnum.Token) as string }
    ];

    // Adicionar parâmetros dinâmicos
    Object.entries(parametros).forEach(([key, value]) => {
      urlParams.push({ key: key as RouteParamters, value: value });
    });

    // Fechar modal e redirecionar
    setModalParam(undefined);
    Redirect(sistema.UrlBase, urlParams);
  }, [props.sistemas, modalparam]);


  useEffect(() => {
    const usuarioID = _UserData.Get(UserDataBaseEnum.UsuarioID);
    if (usuarioID) {
      props.GetSistemas(Number(usuarioID));
    }
  }, [props.GetSistemas])

  return (
    <View>
      <S.Container>
        {props.sistemas && props.sistemas.map((s, index) =>
          <S.AppCard key={index}>
            <S.CardContent>

              <S.ImageContainer>
                <WdLogo size='60px' />
              </S.ImageContainer>
              <S.TextContainer>
                <S.Title>{s.Titulo}</S.Title>
                <S.Content>{s.Descricao}</S.Content>
              </S.TextContainer>
              <S.ArrowContainer onClick={handlerCard(s)}>
                <S.ArrowIcon>→</S.ArrowIcon>
              </S.ArrowContainer>

              {modalparam && modalparam === s.SistemaID &&
                <S.CardParameter onClick={handleModalBackdropClick}>
                  <div onClick={handleModalContentClick}>
                    <Forms
                      handleForm={handleForm}
                      button={
                        <button type='submit'>
                          <S.ArrowContainer style={{ minWidth: 'unset' }} >
                            <S.ArrowIcon>→</S.ArrowIcon>
                          </S.ArrowContainer>
                        </button>}
                    >
                      {s.Parametros && s.Parametros.map((param, index) => (
                        <Input msgError='Preencha o Campo' form={true} label={param} key={index} name={param} />
                      ))}
                    </Forms>
                  </div>
                </S.CardParameter>
              }
            </S.CardContent>
          </S.AppCard>
        )}
        <StateMensage stateLoadingNames={[SISTEMAS_GET]} />
      </S.Container>
    </View >
  )
}

export default connector(Central);
